import React from 'react';
import PropTypes from 'prop-types';
import { string } from 'yup';
import NumberFormat from 'react-number-format';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import BaseInput from './base';

dayjs.extend(customParseFormat);

const validate = val =>
  string()
    .required('Enter your Date of Birth')
    .matches(/^\d{1,2}\d{1,2}(19|20)\d{2}$/, 'Please enter a valid Date of Birth')
    .test('is-date', 'Please enter a valid Date of Birth', value =>
      dayjs(value, 'MMDDYYYY')?.isValid()
    )
    .test('is-at-least-18', 'You must be at least 18', value => {
      const dateValue = dayjs(value, 'MMDDYYYY');
      return dateValue?.isValid() && dayjs().diff(dateValue, 'year') >= 18;
    })
    .validate(val.replace(/[^\d]/g, '').toString())
    .then(() => null)
    .catch(err => err.errors?.join(', '));

const Input = inputProps => (
  <BaseInput
    label="My Date Of Birth"
    type="number"
    name="dob"
    maxLength={15}
    transparent
    autoComplete="off"
    useLocalState={false}
    placeholder="MM/DD/YYYY"
    {...inputProps}
  />
);

const DateOfBirth = ({ onTouched, onChange, ...rest }) => (
  <NumberFormat
    format="##/##/####"
    mask="_"
    onValueChange={values =>
      onChange({ ...values, name: 'dob', type: 'number' }, validate)
    }
    {...rest}
    customInput={Input}
  />
);

DateOfBirth.propTypes = {
  onChange: PropTypes.func.isRequired,
  onTouched: PropTypes.func,
  value: PropTypes.string,
  error: PropTypes.string
};

DateOfBirth.defaultProps = {
  onTouched: null,
  value: '',
  error: ''
};

export default DateOfBirth;
